/** @module SiteAdmin/AggregateCommentCategoryController */
define([
	"dojo/_base/declare",
	"lodash",
	"csi/heading/_AggregateWithNewMixin",
	"csi/heading/AggregateController",
	"csi/xml",
	"SiteAdmin/BusinessObject",
], function (declare, _, _AggregateWithNewMixin, AggregateController, xml, BusinessObject) {
	const APPLICABLE_TYPES = "ApplicableTypes";

	return declare([AggregateController, _AggregateWithNewMixin], {
		aggregateNewNodeType: "CommentCategorySetup",

		/**
		 * @override
		 * Update the ApplicableTypes once user makes change
		 */
		toWriter: function () {
			this.inherited(arguments);

			const bo = this.getNode();
			const typeName = BusinessObject.getRootType(bo);

			const {
				newValue,
				oldValue,
			} = this;

			// if the value is not an array, then it should come from the add Action
			const bAddNew = !Array.isArray(newValue);
			let addedNodes = [];
			let removedNodes = [];

			if (!bAddNew) {
				addedNodes = _.difference(newValue, oldValue);
				removedNodes = _.difference(oldValue, newValue);
			} else {
				addedNodes = [newValue];
			}


			// add the type to the list
			addedNodes.forEach((nodeURL) => {
				this.m_writer.changeNode(nodeURL).changeAttribute(APPLICABLE_TYPES, xml.ATTR_STRINGSET, [typeName], true);
			});

			// remove the type from the list
			removedNodes.forEach((nodeURL) => {
				this.m_writer.changeNode(nodeURL).changeAttribute(APPLICABLE_TYPES, xml.ATTR_STRINGSET, [typeName], false, true);
			});

			// marked with true so that user knows update configuration is required
			this.m_writer.changeNode(bo.$URL).changeAttribute("Modified", xml.ATTR_BOOLEAN, true);
		}
	});
});